import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import Nav from '../template/nav';

export default function withAuth(ComponentToProtect) {
    return class extends Component {
        constructor() {
            super();
            this.state = {
                loading: true,
                redirect: false
            };
        }
        componentDidMount() {
            const self = this;

            setTimeout(() => {
                fetch('/api/auth/session')
                .then(res => {
                    if (res.status === 200) {
                        return res.json();
                    } else {
                        const error = new Error(res.error);
                        throw error;
                    }
                })
                .then(data => {
                    self.setState({ loading: false, redirect: !data.user });
                })
                .catch(err => {
                    console.error(err);
                    self.setState({ loading: false, redirect: true });
                }
            );
            }, 100);
            
        }
        render() {
            let { loading, redirect } = this.state;

            if (loading) {
                return null;
            }
            if (redirect) {
                return <Redirect to="/login" />;
            }
            return (
                <React.Fragment>
                    <Nav />
                    <ComponentToProtect {...this.props} />
                </React.Fragment>
            );
        }
    }
}
